import di from 'di'
import Vue from 'global-vue'

import defaultConfig from 'app/config/config.default';
import developmentConfig from 'app/config/config.development';
import stagingConfig from 'app/config/config.staging';
import productionConfig from 'app/config/config.production';

import AuthManager from '@wittignl/js-core/auth/Manager'
import StorageService from '@wittignl/js-core/services/StorageService';

import MunisenseService from "app/services/MunisenseService";
import AppSwitcherService from "app/services/AppSwitcherService";
import RelayAccountType from 'app/auth/RelayAccountType';

export default class {

    run(){

        /* CONFIG */
        var config = defaultConfig;
        var envConfig = {};

        if(ENV == 'development'){
            envConfig = developmentConfig;
        }
        else if(ENV == 'staging'){
            envConfig = stagingConfig;
        }
        else if(ENV == 'production'){
            envConfig = productionConfig;
        }

        Object.assign(config, envConfig);
        di.set('config', config);

        di.set('storage', new StorageService('logger:2_'));

        /* AUTH */
        di.factory('auth', () => {

            var authManager = new AuthManager(di.get('logger'), window.localStorage);
            authManager.setSessionKey('session-admin');
            authManager.registerAccountType(RelayAccountType.NAME, new RelayAccountType);

            authManager.restoreSession();

            return authManager;
        });

        di.set('selectedLoggers', null);

        /* MUNISENSE */
        di.factory('munisense', () => new MunisenseService());

        // SHORTCUTS
        di.shortcut(Vue, ['config', 'storage']);

        di.factory('appSwitcher', () => new AppSwitcherService());

        // User shortcut
        Object.defineProperty(Vue.prototype, '$user', {
            get () { return di.get('auth').getSession().getIdentity(); }
        });
    }
}
